/* eslint-disable react/prop-types */
import React from 'react';
import { useTheme } from 'styled-components';
import Icon from '../Icon';
import { tokens, orange } from '../tokens';

// Orange-tinted square holding an orange glyph, with the signature halo ring.
const IconTile = ({ icon, size = 46, iconSize = 26 }) => {
  const t = tokens(useTheme());
  return (
    <div
      style={{
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: Math.round(size * 0.3),
        background: orange(0.13),
        border: '1.5px solid ' + orange(0.55),
        boxShadow: t.halo,
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Icon name={icon} size={iconSize} color={t.primary} strokeWidth={2.25} />
    </div>
  );
};

export default IconTile;
